import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
/* reducer */
import * as fromPharmacyDataStore from './state/pharmacy-data-store.reducer';

/* effects */
import { PharmacyDataStoreEffects } from './state/pharmacy-data-store.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    /* PharmacyDataStore State */
    StoreModule.forFeature(
      fromPharmacyDataStore.featureKey,
      fromPharmacyDataStore.reducer,
      { initialState: fromPharmacyDataStore.initialState },
    ),
    EffectsModule.forFeature([PharmacyDataStoreEffects]),
  ],
  exports: [StoreModule, EffectsModule],
})
export class PharmacyDataStoreModule {}
